/** 证件类型 */
export const cardType = {
  /** 居民身份证 */
  ID_CARD: '111',
  /** 普通护照 */
  PORT_PASS: '414',
  /** 台湾居民来往大陆通行证 */
  CONTINENTAL_PASS: '511',
  /** 港澳居民来往内地通行证 */
  INLAND_PASS: '516',
  /** 中国人民解放军 */
  SOLDIER_PASS: '114',
  /** 外国人永久居留证 */
  PERMANENT_PASS: '553',
  /** 其他 */
  OTHER_CARD: '999',
}

/** 页面 */
export const page = {
  /** 服务页 */
  SERVICE: 'service',
  /** 我的页面 */
  MINE: 'mine',
  /** 就业服务机构 */
  SHOP: 'shop',
  /** 零工市场查询 */
  MARKET: 'marketInquiry',
  /** 办事服务 */
  Work: 'workService',
  /**推荐 */
  RECOMMEND: 'recommend',
}

/** 登录用户的类型 */
export const userType = {
  /** 用户--5 */
  USER: 5,
  /** 企业--6 */
  UNIT: 6
}

/** 链接的类型 */
export const urlType = {
  /** 用户--1 */
  USER: 1,
  /** 企业--2 */
  UNIT: 2
}

/** 审核状态 */
export const reviewType = {
  /** 审核成功--1 */
  SUCCESS: 1,
  /** 审核中--0 */
  ING: 0,
  /** 审核失败--2 */
  FAIL: 2
}

export const sex = {
  /** 男--1 */
  BOY: 1,
  /** 女--2 */
  GIRL: 2,
}

/** 表单字段名称（通常用来判断label） */
export const labelValue = {
  /** 暂无数据 */
  NODATA: '暂无数据',
}

/**树形节点 */
export const treeType = {
  /** 普通节点 */
  NORMAL: 0,
  /** 根节点 */
  ROOT: 1,
  /** 末节点 */
  END: 2
}

export const date = {
  YEAR: 'year',
  MONTH: 'month',
  DAY: 'day',
  ONLYMONTH: 'onlyMonth'
}

/**　表单渲染类型 */
export const formType = {
  /** 文本框 */
  INPUT: 'input',
  /** 单选:数据字典 */
  PICKER: 'picker',
  /** 选择民族 */
  NATIONPICKER: 'nationPicker',
  /** 单选:固定选项 */
  CHOOSE: 'choose',
  /** 日期选择 */
  DATEPICKER: 'datePicker',
  /** 多选:多个选项合并在一起 */
  MANYCASCADE: 'manyCascade',
  /** 多行文本框 */
  TEXTAREA: 'textarea',
  /** 上传文件 */
  UPLOAD: 'upload',
  /**　多选：树形选择框 */
  CASCADER: 'cascader',
  /** 手机号验证 */
  VERIFICATIONCODE: 'verificationCode',
  /**个人承诺 */
  CHECKBOX: 'checkBox'
}

export const formName = {
  /** '就业困难人员认定' */
  AFFIRMEMPLOY: '就业困难人员认定',
  /** '社保补贴申请' */
  SUBSIDY: '社保补贴申请'
}

export const progressCheck = {
  /** 认定结果:'status' */
  STATUS: 'status',
  /** 申请结果:'vieStatus' */
  VIESTATUS: 'vieStatus',
  /** 公示结果:'publStatus' */
  PUBLSTATUS: 'publStatus',
  /** 补贴情况:'releaStatus' */
  RELEASTATUS: 'releaStatus'
}


// 十二个月的option选择
let monthOptions = []
for (let i = 1; i <= 12; i++) {
  if (i < 10) {
    monthOptions.push({ label: '0' + i + '月', value: '0' + i })
  } else {
    monthOptions.push({ label: i + '月', value: i })
  }
}
export { monthOptions }

/** 为真 */
export const TRUE_FLAG_NUM = 1
/**为假 */
export const FALSE_FLAG_NUM = 0
// 其他
export const OTHER_NUM = 2


// TODO：是否是开发环境
export const IsDev = true
// export const IsDev = false




